import { ErrorMessage as UnstyledErrorMessage, withClassName } from '@epages/react-components'

export default withClassName('dali-settingslayer-element-invalid-message form-element-invalid-message')(
  UnstyledErrorMessage,
)
